var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('form',{staticClass:"dropzone",attrs:{"action":"/gallery/save","id":"my-great-dropzone"}})}
var staticRenderFns = []

export { render, staticRenderFns }